export default [
  {
    key: 'member_status',
    value: [],
    label: 'ステータス',
    name: 'member_status',
    as: 'checkboxGroup',
  },
  {
    key: 'admin_note',
    value: '',
    label: '備考',
    name: 'admin_note',
    as: 'input',
    placeholder: 'キーワードをスペースで区切り入力してください',
    rules: {
      required: false,
      max: 1000,
    },
  },
]
